import { IApiGetChannelsParam, IApiGetDemoDataParam, IChannel } from '../interfaces/api';
import { call, delay, put, takeLatest } from 'redux-saga/effects';
import apis from './apis';
import actions from './actions';
import { AxiosResponse } from 'axios';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import { ISagaFunc } from 'services/actionConfigs';
import { setPageLoading } from 'widgets/PageLoading';
import { IResponseData } from 'services/response';
import { PaginationResponse } from 'services/commonTypes';

const getDemoData: ISagaFunc<IApiGetDemoDataParam> = function* () {
  try {
    const resData: AxiosResponse<{ data: IDEMOModelResDataItem[] }> = yield call(apis.getDemoData);
    if (resData?.data?.data) {
      yield put(actions.getDemoData.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getDemoData.fail({}));
  } finally {
  }
};

const getListChannels: ISagaFunc<IApiGetChannelsParam> = function* ({ payload }) {
  setPageLoading(true);
  yield delay(200);
  try {
    const resData: IResponseData<PaginationResponse<IChannel>> = yield call(apis.getListChannels, payload);
    if (resData?.data?.data) {
      yield put(actions.getListChannels.success({
        list: resData.data.data.content,
        total: resData.data.data.totalElements,
        from: payload.page,
      }));
    }
  } catch (error) {
    yield put(actions.getListChannels.fail({}));
  } finally {
    setPageLoading(false);
  }
};

const getListLayouts: ISagaFunc<void> = function* () {
  setPageLoading(true);
  yield delay(200);
  try {
    const resData: AxiosResponse<{ data: any[] }> = yield call(apis.getListLayouts);
    if (resData?.data?.data) {
      yield put(actions.getListLayouts.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getListLayouts.fail({}));
  }
  finally {
    setPageLoading(false);
  }
};

const deleteChannel: ISagaFunc<string> = function* ({ payload }) {
  setPageLoading(true);
  yield delay(200);
  try {
    const resData: IResponseData<{data: boolean}> = yield call(apis.deleteChannel, payload);
    if (resData?.data?.data) {
      yield put(actions.deleteChannel.success(payload));
    }
  } catch (error) {
    yield put(actions.deleteChannel.fail({}));
  } 
  finally {
    setPageLoading(false);
  }
};

export default function* channelServiceSagas() {
  yield takeLatest(actions.getDemoData.fetch, getDemoData);
  yield takeLatest(actions.getListChannels.fetch, getListChannels);
  yield takeLatest(actions.getListLayouts.fetch, getListLayouts);
  yield takeLatest(actions.deleteChannel.fetch, deleteChannel);
}
